const paths = {
    rename: 'm16 3 5 5-12 12-6 1 1-6L16 3Z M14 5l5 5',
    move: 'M21 10V7a2 2 0 0 0-2-2h-7l-2-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7 M14 16h8m-4-4 4 4-4 4',
    archive: 'M4 8h16v12H4z M3 4h18v4H3z M9 12h6',
    delete: 'M3 6h18 M9 6V3h6v3 M5 6l1 15h12l1-15 M10 10v7 M14 10v7',
};

export default function ModelActionIcon({ action }) {
    return <svg className="model-action-icon" viewBox="0 0 24 24" width="18" height="18"
        fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"
        aria-hidden="true" focusable="false">
        <path d={paths[action]} />
    </svg>;
}
